import $ from 'jquery'
import {Swiper, Navigation, Autoplay, Lazy, Scrollbar, Pagination} from 'swiper';
Swiper.use([ Navigation, Autoplay, Lazy, Scrollbar, Pagination]);

const serviceSwiper = new Swiper('.swiper-product-categories', {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
        1300: {
            slidesPerView: 4
        },
        800: {
            slidesPerView: 2.5
        },
        480: {
            slidesPerView: 1.5
        },
        300: {
            slidesPerView: 1
        }
    },
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
    },
});

function updateSliderConfig() {
    let numSlides = serviceSwiper.slides.length;
    let windowWidth = $(window).innerWidth()
    let productWrapper = $('.swiper-product-categories .swiper-wrapper')

    // Check conditions and update configuration
    if (windowWidth > 1300 && numSlides >= 4 ||
        windowWidth > 800 && windowWidth < 1300 && numSlides > 2 ||
        windowWidth > 480 && windowWidth < 800 && numSlides > 1 ||
        windowWidth > 200 && windowWidth < 480 && numSlides >= 1) {
        productWrapper.removeClass('center-slides');
    } else {
        productWrapper.addClass('center-slides');
    }
}
$(window).on('resize load', updateSliderConfig);